export default "__VITE_ASSET___dwkXsJi__"